import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { Station } from '../../model/station';

export type StationListState = {
  // keyed by owner_id (or 'all' for no vendor filter)
  byVendor: Record<string, Station[]>;
  loading: boolean;
  error: string | null;
};

const initialState: StationListState = {
  byVendor: {},
  loading: false,
  error: null,
};

const slice = createSlice({
  name: 'stationList',
  initialState,
  reducers: {
    fetchStart: (state) => {
      state.loading = true;
      state.error = null;
    },
    fetchSuccess: (
      state,
      action: PayloadAction<{ key: string; stations: Station[] }>
    ) => {
      state.loading = false;
      state.byVendor[action.payload.key] = action.payload.stations;
    },
    fetchFailed: (state, action: PayloadAction<string>) => {
      state.loading = false;
      state.error = action.payload;
    },
  },
});

export const stationList = slice.reducer;
export const { fetchStart, fetchSuccess, fetchFailed } = slice.actions;
